import React from "react";
import PKOReportTable from "./PKOReportTable";

const PKOReport = () => {
  return (
    <div>
      <PKOReportTable />
    </div>
  );
};

PKOReport.ROUTE = {
  url: "pko",
  name: "PKO Report",
  icon: "chart bar",
  description: "View PKO reports",
};

export default PKOReport;
